module.exports = __webpack_public_path__ + "static/media/call-medicare.e5779126.svg";